import React, { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
// import axios from 'axios'; // (optional) keep only if you use it elsewhere

// ------------------- WARNINGS -------------------
// This file uses AWS credentials in client-side code (provided by you).
// This is insecure for production. Recommended: generate presigned URLs
// from your server and upload using PUT/POST to S3 instead.
// -------------------------------------------------

// ---------- AWS CONFIG (same creds you provided earlier) ----------
AWS.config.update({
  accessKeyId: "AKIASSKAY3FYIR5ZCBWH",
  secretAccessKey: "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",
  region: "ap-south-1",
});
const s3 = new AWS.S3({ apiVersion: '2006-03-01' });
const bucketName = "black-box-bucketv2";

// Simple small spinner component (pure CSS)
const FullscreenLoader = ({ open, text }) => {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.45)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      color: '#fff'
    }}>
      <div style={{
        width: 56,
        height: 56,
        borderRadius: 28,
        border: '4px solid rgba(255,255,255,0.15)',
        borderTopColor: '#fff',
        animation: 'spin 1s linear infinite',
        marginBottom: 12
      }} />
      <div style={{ fontSize: 16 }}>{text || 'Uploading...'}</div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  )
}

/* ---------- UploadBox uses S3 now ---------- */
const UploadBox = ({ type, onUpload, setUploading }) => {
  const [progressState, setProgressState] = useState(0);
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    const isVideo = selectedFile.type.startsWith('video');

    // Validation: image <= 500KB, video <= 2MB
    if (!isVideo && selectedFile.size > 500 * 1024) {
      setError('Image size should be less than 500 KB');
      e.target.value = '';
      return;
    }
    if (isVideo && selectedFile.size > 2 * 1024 * 1024) {
      setError('Video size should be less than 2 MB');
      e.target.value = '';
      return;
    }

    setError(null);

    // Prepare S3 params
    const fileTypeFolder = isVideo ? 'videos' : 'images';
    const fileName = `${Date.now()}-${selectedFile.name}`;
    const params = {
      Bucket: bucketName,
      Key: `${fileTypeFolder}/${fileName}`,
      Body: selectedFile,
      ContentType: selectedFile.type,
    };

    // Start upload
    setUploading(true);
    setProgressState(0);
    try {
      const upload = s3.upload(params);

      upload.on('httpUploadProgress', (progressEvent) => {
        if (progressEvent && progressEvent.total) {
          const pct = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setProgressState(pct);
        }
      });

      const data = await upload.promise();
      const fileUrl = data.Location; // S3 URL (or CloudFront URL if configured)

      // Notify parent with a robust shape
      onUpload({
        url: fileUrl,
        name: selectedFile.name,
        size: selectedFile.size,
        isVideo,
      });

      setProgressState(100);
    } catch (err) {
      console.error('S3 upload error:', err);
      setError('Upload failed. Please try again.');
    } finally {
      // small delay so user sees 100% briefly
      setTimeout(() => {
        setProgressState(0);
        setUploading(false);
      }, 400);
      // Reset the input so the same file can be selected again if needed
      e.target.value = '';
    }
  };

  // clickable label triggers the hidden input
  return (
    <div className="box imageBox fsbfont" style={{ position: 'relative' }}>
      <label
        className="box-content"
        onClick={() => document.getElementById(`file-input-${type}`).click()}
        style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: 14 }}
      >
        <div className="f2 gl mb-4 mt-3" style={{ fontSize: 28 }}>+</div>
        <div className='f22 gl'>{type === 'image' ? '.png/.jpg' : '.mp4 (any video)'}</div>
        {progressState > 0 && (
          <div style={{ marginTop: 8, fontSize: 13 }}>{progressState}%</div>
        )}
        {error && <div style={{ color: '#d32f2f', marginTop: 8, fontSize: 13 }}>{error}</div>}
      </label>

      <input
        id={`file-input-${type}`}
        type="file"
        accept={type === 'image' ? 'image/*' : 'video/*'}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

/* ---------- Uploaded file summary component ---------- */
const UploadedFileBox = ({ url, name, size, isVideo, onDelete }) => {
  return (
    <div className="uploaded-file-box" style={{
      border: '1px solid #eee',
      padding: 10,
      borderRadius: 8,
      marginBottom: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div className="file-info fsbfont" style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</div>
        <div className='sizeOfFile' style={{ color: '#666' }}>{(size / 1024).toFixed(2)} KB</div>
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {/* small preview */}
        {isVideo ? (
          <video src={url} controls width="140" style={{ borderRadius: 6, objectFit: 'cover' }} />
        ) : (
          <img src={url} alt={name} width="140" style={{ objectFit: 'cover', borderRadius: 6 }} />
        )}
        <button onClick={onDelete} className='sixeFileDel gm' style={{
          background: '#fff',
          border: '1px solid #ddd',
          padding: '6px 10px',
          borderRadius: 6,
          cursor: 'pointer'
        }}>Delete</button>
      </div>
    </div>
  );
};

/* ---------- Main Verification component ---------- */
const Verification = ({ infoTaker, sect3 }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploading, setUploading] = useState(false); // controls fullscreen loader

  const handleFileUpload = (fileObj) => {
    setUploadedFiles(prevFiles => [...prevFiles, fileObj]);
  };

  useEffect(() => {
    // if sect3 has preloaded images (initial value), set them
    if (sect3 && sect3.img) {
      const arr = Array.isArray(sect3.img) ? sect3.img : [];
      // Normalize any legacy items that might not have isVideo/type
      const normalized = arr.map(f => {
        const url = f?.url || '';
        const typeHint = f?.type || '';
        const guessIsVideo =
          (typeof url === 'string' && url.toLowerCase().includes('.mp4')) ||
          (typeof typeHint === 'string' && typeHint.startsWith('video'));
        return {
          url,
          name: f?.name || 'file',
          size: Number(f?.size || 0),
          isVideo: typeof f?.isVideo === 'boolean' ? f.isVideo : !!guessIsVideo,
        };
      });
      setUploadedFiles(normalized);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // propagate uploaded files to parent via infoTaker
    if (typeof infoTaker === 'function') {
      infoTaker(3, "img", uploadedFiles);
    }
  }, [uploadedFiles, infoTaker]);

  const handleFileDelete = (index) => {
    setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  // Derive first image and first video for the two top boxes
  const firstImage = uploadedFiles.find(f => !f.isVideo);
  const firstVideo = uploadedFiles.find(f => f.isVideo);

  return (
    <>
      {/* Fullscreen loader */}
      <FullscreenLoader open={uploading} text={`Uploading...`} />

      <div className='Claser' style={{ opacity: uploading ? 0.6 : 1, pointerEvents: uploading ? 'none' : 'auto' }}>
        <div>
          <div className='fsbfont headingForClassInfo fscc'>
            Submit Your Photos and Videos
          </div>
          <div className='VFDTitle fscc2 frfont '>
            These images will help your peers to get a preview of session
          </div>
        </div>

        <div>
          <div className='fsbfont headingForClassInfo fscc'>
            Upload Files
          </div>
          <div className='VFDTitle fscc2 frfont '>
            Drag and drop your files here or click on the boxes
          </div>
        </div>

        <div className="uploadRow" style={{ display: 'flex', gap: 12 }}>
          {/* Left slot: first image or an image upload box */}
          {firstImage ? (
            <img
              src={firstImage.url}
              className='imageBox'
              alt={firstImage.name}
              style={{ width: 220, height: 140, objectFit: 'cover', borderRadius: 8 }}
            />
          ) : (
            <UploadBox type="image" onUpload={handleFileUpload} setUploading={setUploading} />
          )}

          {/* Right slot: first video or a video upload box */}
          {firstVideo ? (
            <video
              src={firstVideo.url}
              controls
              width="220"
              style={{ height: 140, borderRadius: 8, objectFit: 'cover' }}
            />
          ) : (
            <UploadBox type="video" onUpload={handleFileUpload} setUploading={setUploading} />
          )}
        </div>

        <div>
          <div className='VFDTitle fscc2 frfont'>
            *Only upload .jpg and .png files up to 500 KB max and video limit up to 2 MB.
          </div>
        </div>

        <div className='fsbfont headingForClassInfo fscc' style={{ marginTop: 18 }}>
          Uploaded Files
        </div>

        <div style={{ marginTop: 8 }}>
          {uploadedFiles.length === 0 && <div style={{ color: '#666' }}>No files uploaded yet</div>}
          {uploadedFiles.map((file, index) => (
            <UploadedFileBox
              key={`${file.url}-${index}`}
              url={file.url}
              name={file.name}
              size={file.size}
              isVideo={file.isVideo}
              onDelete={() => handleFileDelete(index)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Verification;
